import {
  Button,
  //   DatePicker,
  Drawer,
  Form,
  //   Input,
  InputNumber,
  //   Select,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../../context";
import moment from "moment";

const MerchantEmployeeExtendService = ({
  open,
  close,
  setLoading,
  getMerchantOrderSaveList,
  selectedData,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleExtendService = (values) => {
    const formdata = new FormData();
    formdata.append(
      "user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("transaction_id", selectedData.transaction_id);
    formdata.append(
      "new_service_duration",
      parseInt(selectedData.data[0].service_duration) + values.service_duration
    );
    formdata.append(
      "ended_date",
      moment(new Date(selectedData.data[0].ended_date))
        .add(
          values.service_duration,
          selectedData.data[0].service_duration_unit === "hour"
            ? "hours"
            : selectedData.data[0].service_duration_unit === "day"
            ? "days"
            : "months"
        )
        .format("YYYY-MM-DD HH:mm")
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/update-avail-service", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated avail service successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Extend Service"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="extend-services2"
        initialValues={{
          service_desc: "",
        }}
        onFinish={handleExtendService}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="service_duration"
            label={`How Many ${selectedData.data[0].service_duration_unit}(s)`}
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={1}
              max={999999999999}
              initialvalues={1}
              size="large"
              style={{ width: "100%" }}
              step="1"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantEmployeeExtendService;
